import { useReactiveVar } from '@apollo/client'
import CardGrid from '@components/design-system/CardGrid'
import CardLoader from '@components/design-system/CardLoader'
import EmptyState from '@components/shared/EmptyState'
import { DefaultPageTemplate } from '@components/shared/templates/DefaultPageTemplate'
import { blacklist, SupportedNetworks } from '@config'
import { crowdPadFiltersVar } from '@graphql/variables/CrowdPadVariable'
import { useCrowdpadItems } from '@hooks/crowdpad/CrowdpadHooks'
import { GetServerSideProps } from 'next'
import CrowdPadFilters from '../../../components/crowdpad/CrowdPadFilters'
import CrowdPadHeader from '../../../components/crowdpad/CrowdpadHeader'
import CrowdpadCard from '../../../components/shared/cards/CrowdpadCard'

interface CrowdPadPageProps {
  chainId: number
}

export default function CrowdPadPage({ chainId }: CrowdPadPageProps) {
  const crowdpadFilters = useReactiveVar(crowdPadFiltersVar)
  const crowdpadItems = useCrowdpadItems(chainId, crowdpadFilters)
  return (
    <DefaultPageTemplate header={<CrowdPadHeader chainId={chainId} />}>
      <CrowdPadFilters />
      {!crowdpadItems.loading && !crowdpadItems.crowdPadItems.length && !crowdpadItems.hasMore && <EmptyState />}
      <CardGrid
        hasMore={crowdpadItems.hasMore}
        loader={<CardLoader />}
        loadMore={crowdpadItems.loadMore}
        data={crowdpadItems.crowdPadItems.map(
          nftItem => !blacklist.includes(`${nftItem.chainId}_${nftItem.id}`) && <CrowdpadCard crowdpadItem={nftItem} key={nftItem.id} />
        )}
      />
    </DefaultPageTemplate>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const chainId = context.params?.chainId || SupportedNetworks.ethereum

  return {
    props: {
      chainId: Number(chainId)
    }
  }
}
